import { File, Image, X, Check } from 'lucide-react';

const FilePreview = ({ fileObj, removeFile }) => {
  const getFileIcon = (type) => {
    if (type.startsWith("image/")) {
      return <Image className="w-4 h-4 text-blue-500" />;
    }
    return <File className="w-4 h-4 text-red-500" />;
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0B";
    const k = 1024;
    const sizes = ["B", "KB", "MB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + sizes[i];
  };
  return (
    <div className="relative bg-gray-50 rounded-lg p-2 group hover:bg-gray-100 transition-colors border border-gray-200">
      <button
        onClick={() => removeFile(fileObj.id)}
        className="absolute -top-1 -right-1 w-5 h-5 bg-gray-600 hover:bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all z-10"
      >
        <X className="w-3 h-3" />
      </button>

      <div className="flex items-center space-x-2">
        <div className="flex-shrink-0">
          {fileObj.preview ? (
            <img
              src={fileObj.preview}
              alt={fileObj.name}
              className="w-8 h-8 object-cover rounded"
            />
          ) : (
            <div className="w-8 h-8 bg-white rounded flex items-center justify-center border border-gray-300">
              {getFileIcon(fileObj.type)}
            </div>
          )}
        </div>

        {/* File Info */}
        <div className="flex-grow min-w-0">
          <p className="text-xs font-medium text-gray-900 truncate">
            {fileObj.name}
          </p>
          <div className="flex items-center space-x-1 mt-1">
            <p className="text-xs text-gray-500">
              {formatFileSize(fileObj.size)}
            </p>
            {fileObj.uploaded ? (
              <Check className="w-3 h-3 text-green-500" />
            ) : (
              <div className="animate-spin rounded-full h-2 w-2 border border-blue-500 border-t-transparent"></div>
            )}
          </div>
        </div>
      </div>
    </div>

    // <div className="flex-shrink-0 mr-4">
    //   {file.preview ? (
    //     <img
    //       src={file.preview}
    //       alt={file.name}
    //       className="w-12 h-12 object-cover rounded-lg"
    //     />
    //   ) : (
    //     <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center border border-gray-200">
    //       {getFileIcon(file.type)}
    //     </div>
    //   )}
    // </div>
  );
}

export default FilePreview